import React, { useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader,Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import './Lmu.css';
import PastureDrainageForm from './PastureDrainageForm';
import SoilForm from './SoilForm';
import StrengthsForm from './StrengthsForm';
import WeaknessesForm from './WeaknessesForm';

const FurtherDetailForm = ({ formPastureDrainage, formSoil, formStrengths, formWeaknesses, isNonContiguous, editableKeyToFocus, handleFormFieldChange }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    return (
        <Card className="my-3">
            <CardHeader className="card-header-click" onClick={toggle}>
                <Row>
                    <Col sm="11">
                        <h6>Advanced Soils, Pasture and Drainage</h6>
                    </Col>
                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    <PastureDrainageForm form={formPastureDrainage} handleFormFieldChange={(e) => handleFormFieldChange(e)} />
                    <SoilForm form={formSoil} editableKeyToFocus={editableKeyToFocus} />
                    {/*{*/}
                    {/*    !isNonContiguous &&*/}
                    {/*    <>*/}
                    {/*        <StrengthsForm form={formStrengths} />*/}
                    {/*        <WeaknessesForm form={formWeaknesses} />*/}
                    {/*    </>*/}
                    {/*}*/}
                </CardBody>
            </Collapse>
        </Card>
    )
}


export default FurtherDetailForm